const quotes = [
  {
    key: 'vrijheidInOpleidingsmogelijkheden',
    illustration: '/images/quotes/vrijheidInOpleidingsmogelijkheden.png',
    shortQuote: 'Vrijheid in opleidings&shy;mogelijkheden',
    longQuote: '“Platte structuur en korte lijnen. <strong>Vrijheid in opleidings&shy;mogelijkheden</strong>. Wil je naar een congres of wil je een cursus volgen? Beiden is mogelijk. Primaire en secundaire arbeidsvoorwaarden zijn gewoon goed.”'
  },
  {
    key: 'sollicitatieOpHetTerras',
    illustration: '/images/quotes/sollicitatieOpHetTerras.png',
    shortQuote: 'Sollicitatie op het terras',
    longQuote: '“Vanaf de <strong>sollicitatie op het terras</strong> tot waar we nu zijn heb ik me prima vermaakt bij Blue4IT. Ook op informeel vlak kennen we elkaar allemaal en is het altijd erg gezellig bij de activiteiten die we met elkaar ondernemen.”'
  },
  {
    key: 'veelVrijheid',
    illustration: '/images/quotes/veelVrijheid.png',
    shortQuote: 'Veel vrijheid',
    longQuote: '“Je krijgt <strong>veel vrijheid</strong>; leuke kennissessies met geweldige sprekers (met heerlijk eten); prima studiebudget; toegang tot gave events; allemaal geweldige collega’s; moet ik nog doorgaan? Groeten uit San Francisco!”'
  },
  {
    key: 'deLaatsteTechniek',
    illustration: '/images/quotes/deLaatsteTechniek.png',
    shortQuote: 'De laatste techniek',
    longQuote: '“Wil jij een project met <strong>de laatste techniek</strong> dan gaat Michel (red: de manager) daarvoor zorgen. Wil jij een bepaald onderwerp in een kennisavond dan wordt dat in de groep gegooid. Grote kans dat het aan bod komt en zo niet heb je een ruim kennisbudget om alsnog kennis te vergaren.”'
  },
  {
    key: 'allesDirectBespreken',
    illustration: '/images/quotes/allesDirectBespreken.png',
    shortQuote: 'Alles direct bespreken',
    longQuote: '“Je kan met Michel in principe <strong>alles direct bespreken</strong>. Doelen en jaar review worden informeel tijdens de lunch besproken. Geen onzinnige management tools als persoonlijke ontwikkel plan oid.”'
  },
  {
    key: 'geenGezever',
    illustration: '/images/quotes/geenGezever.png',
    shortQuote: 'Geen gezever',
    longQuote: '“<strong>Geen gezever</strong> over POP’s en man-manager gesprekken. Zoals Michel ooit zei: hij bewaakt mijn CV. Verder heb ik de vrijheid om te bekijken wat ik zelf leuk en relevant vind.”'
  }
];

export default {
  template: `
      <section class="Quotes Section Section--coloredLight">
        <div class="ms-Grid">
          <div class="ms-Grid-row">
            <div class="ms-Grid-col ms-sm12 ms-xl6 ms-xlPush6">
              <h2 class="Section-heading">
                Hoe is het bij Blue4IT?
              </h2>
            </div>
          </div>
          <div class="ms-Grid-row">
            <div class="ms-Grid-col ms-sm12">
              <div class="Section-body Quotes-box">
                <div v-parallax.absY="-0.1" v-for="item in items" v-bind:class="['Quotes-boxItem', 'Quotes-boxItem--' + item.key]">
                  <div class="Quotes-illustration">
                    <img v-bind:src="item.illustration" alt="">
                  </div>
                  <button v-bind:class="['Quotes-shortQuote', { 'Quotes-shortQuote--open': selectedKey === item.key }]" @click="selectItem(item.key)">
                    <span class="Quotes-shortQuoteText" v-html="item.shortQuote"></span>
                  </button>
                  <div class="Quotes-longQuote">
                    <p v-html="item.longQuote"></p>
                    <button class="Quotes-closeButton" @click="closeItem()">
                      <span class="Quotes-closeButtonText">Sluiten</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `,
  data: function () {
    return {
      items: quotes,
      selectedKey: ''
    };
  },
  methods: {
    selectItem: function (key) {
      this.selectedKey = key;
    },
    closeItem: function () {
      this.selectedKey = '';
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/components/quotes-section.component.js